import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

const LegalLayout = ({ title, children, testId }) => (
  <section className="max-w-3xl mx-auto px-4 sm:px-8 py-16 md:py-24" data-testid={testId}>
    <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-chocolate">
      {title}
    </h1>
    <div className="mt-8 space-y-5 text-base leading-relaxed text-cocoa">{children}</div>
    <Link
      to="/"
      data-testid={`${testId}-back-link`}
      className="mt-10 inline-flex items-center gap-2 text-sm font-medium text-caramel transition-colors hover:text-caramel-dark"
    >
      <ArrowLeft className="w-4 h-4" />
      Voltar ao início
    </Link>
  </section>
);

export const Privacidade = () => (
  <>
    <Seo title="Política de Privacidade | Doce Casa" siteName="Doce Casa" description="Política de privacidade do website da Doce Casa." />
    <LegalLayout title="Política de Privacidade" testId="privacy-page">
      <p>
        Este website é apenas informativo: não recolhe dados pessoais através de
        formulários, não requer criação de conta e não utiliza cookies de
        rastreamento para fins de marketing.
      </p>
      <p>
        As encomendas são feitas por mensagem direta no WhatsApp. Nessa
        conversa, apenas te pedimos os dados necessários para preparar e
        entregar a tua encomenda (nome, contacto, data e morada de entrega,
        quando aplicável). Esses dados são usados exclusivamente para esse fim e
        nunca são partilhados com terceiros.
      </p>
      <p>
        Se tiveres alguma questão sobre os teus dados, fala connosco através do
        WhatsApp.
      </p>
    </LegalLayout>
  </>
);

export const Termos = () => (
  <>
    <Seo title="Termos e Condições | Doce Casa" siteName="Doce Casa" description="Termos e condições das encomendas da Doce Casa." />
    <LegalLayout title="Termos e Condições" testId="terms-page">
      <p>
        As encomendas são feitas exclusivamente por mensagem no WhatsApp e ficam
        confirmadas apenas após validação da disponibilidade. Recomendamos uma
        antecedência mínima de 5 dias.
      </p>
      <p>
        Os preços são fornecidos sob consulta, de acordo com o tamanho, recheio,
        cobertura e decoração escolhidos. Não efetuamos vendas nem pagamentos
        através deste website.
      </p>
      <p>
        Fazemos entregas na Amadora, Grande Lisboa e arredores, mediante
        disponibilidade e confirmação do valor da entrega.
      </p>
      <p>
        Sabores, decoração e disponibilidade podem variar e estão sujeitos a
        confirmação no momento da encomenda.
      </p>
    </LegalLayout>
  </>
);

export const Alergenios = () => (
  <>
    <Seo title="Informação sobre alergénios | Doce Casa" siteName="Doce Casa" description="Informação sobre alergénios nos produtos da Doce Casa." />
    <LegalLayout title="Informação sobre alergénios" testId="allergens-page">
      <p>
        Os nossos doces são preparados artesanalmente numa cozinha onde se
        utilizam, entre outros, os seguintes alergénios: cereais que contêm
        glúten, ovos, leite e derivados, e frutos de casca rija.
      </p>
      <p>
        Apesar de todo o cuidado na preparação, não podemos garantir a ausência
        total de vestígios destes ingredientes em qualquer um dos nossos
        produtos.
      </p>
      <p>
        Se tens alguma alergia ou intolerância alimentar, informa-nos sempre no
        momento da encomenda para podermos aconselhar-te da melhor forma.
      </p>
    </LegalLayout>
  </>
);
